export const ROOT_PATH = '/';
export const BASE_PATH = '/account/branding';
export const EDIT_URL_SUBPATH = `${BASE_PATH}/brands`;
export const PREVIEW_URL_SUBPATH = `${BASE_PATH}/preview`;

// screens
export const URL_LIST_BRANDS = `${BASE_PATH}`;
export const URL_CREATE_BRAND = `${BASE_PATH}/create`;
export const URL_EDIT_BRAND = `${EDIT_URL_SUBPATH}/:id`;
export const URL_BRAND_REPORT = `${BASE_PATH}/report`;
export const URL_PREVIEW_BRAND = `${PREVIEW_URL_SUBPATH}/:id`;

// navigations
export const URL_LOGOS_LEGACY = '/account/logos';

// services
const IMAGE_SERVICE_APP_NAME = `image-service-api`;
export const IMAGE_SERVICE_URL_DEV = `https://${IMAGE_SERVICE_APP_NAME}.staging.cloud.seek.com.au`;
export const IMAGE_SERVICE_URL_PROD = `https://${IMAGE_SERVICE_APP_NAME}.cloud.seek.com.au`;

export const HIRER_GRAPHQL_STAGING =
  'https://talent.staging.seek.com.au/graphql';
